import './List.scss';
import SkapaList, { ListProps as SkapaListProps } from '@ingka/list';

import { PREFIX } from '../constants/constants';

const List = (props: SkapaListProps) => <SkapaList prefix={PREFIX} {...props} />;

export default List;
